document.addEventListener('DOMContentLoaded', (event) => {
  if (!customElements.get('product-form')) {
    customElements.define(
      'product-form',
      class ProductForm extends HTMLElement {
        constructor() {
          super()

          this.selectors = {
            productImagesThumbnailsSlider: '.pdp__images__thumbnails__slider',
            productImagesMainSlider: '.pdp__images__main-slider',
            upsellsSlider: '.pdp__info__upsells__content__slider',
            buildYourRoutineSlider: '.pdp__build-your-routine__content__slider',
            tipsAndTricksSlider: '.pdp__tips-tricks__content__slider',
            similarProductsSlider: '.pdp__similar-products__content__slider',
            shopVideoSlider: '.pdp__shop-video__content__slider',
            shopVideoSliderSlide:
              '.pdp__shop-video__content__slider__wrapper__slide',
            shopVideoSliderSlideActive:
              '.pdp__shop-video__content__slider__wrapper__slide--active',
            variantRadiosContainer: '.pdp__info__variant-radios',
            purchaseTypeInput: 'input[name="purchase-type"]',
            rechargeVariantMap: '#recharge-variant-map',
            thumbnailItem: '.pdp__images__thumbnails__slider__wrapper__item',
            oneTimePrice: '.purchase-type-one-time-price',
            recurringPrice: '.purchase-type-recurring-price',
            rechargeFrequencySelect: '#recharge-frequency',
            bundleVariantsData: '#bundle-variants-data',
          }
          this.form = this.querySelector('form')
          this.form.querySelector('[name=id]').disabled = false
          this.form.addEventListener('submit', this.onSubmitHandler.bind(this))
          this.bundleVariants = this.getBundleVariants()

          // If bundle variants exist, update form to prevent default submission
          if (this.bundleVariants) {
            this.form.querySelector('[name=id]').disabled = true
            // Remove the form's action to prevent any accidental submissions
            this.form.removeAttribute('action')
          }
        }

        async checkVariantQuantity(variantId) {
          try {
            const res = await fetch('/cart.js')
            const data = await res.json()

            const items = data.items

            if (!items.length) {
              return 0
            }

            const item = items.filter(
              (item) => parseInt(item.variant_id) === parseInt(variantId),
            )[0]

            if (!item) {
              return 0
            }

            return item.quantity
          } catch (err) {
            console.error('Error checking variant quantity:', err)
          }
        }

        getBundleVariants() {
          const bundleDataElement = document.querySelector(
            this.selectors.bundleVariantsData,
          )

          if (!bundleDataElement) {
            return null
          }

          try {
            const parsed = JSON.parse(bundleDataElement.textContent)
            return parsed.bundleVariants || null
          } catch (err) {
            console.error('Error parsing bundle variants data:', err)
            return null
          }
        }

        getPurchaseType() {
          const purchaseTypeInputs = document.querySelectorAll(
            this.selectors.purchaseTypeInput,
          )

          if (!purchaseTypeInputs.length) {
            return 'one-time'
          }

          const purchaseType = Array.from(purchaseTypeInputs).filter(
            (input) => input.checked,
          )[0]

          if (purchaseType.id === 'purchase-type-recurring') {
            return 'recurring'
          } else {
            return 'one-time'
          }
        }

        getFrequency() {
          const frequency = document.querySelector(
            this.selectors.rechargeFrequencySelect,
          )

          if (!frequency) {
            return false
          }

          return frequency.options[frequency.selectedIndex].value.trim()
        }

        getRechargeVariantId() {
          let rechargeVariantMap = document.querySelector(
            this.selectors.rechargeVariantMap,
          )
          const variantId = this.form.querySelector('input[name="id"]').value

          if (!rechargeVariantMap || !variantId) {
            return false
          }

          rechargeVariantMap = JSON.parse(rechargeVariantMap.textContent)

          for (let key in rechargeVariantMap) {
            if (key === variantId) {
              return rechargeVariantMap[key]['discount_variant_id']
            }
          }

          return false
        }

        checkBundleVariantsAvailability() {
          if (!this.bundleVariants) {
            return true // If no bundle variants, default availability logic applies
          }

          return this.bundleVariants.every(
            (bundleVariant) => bundleVariant.available,
          )
        }

        async addBundleVariantsToCart() {
          if (!this.bundleVariants) {
            return false
          }

          // Check if all bundle variants are available
          if (!this.checkBundleVariantsAvailability()) {
            console.error('One or more bundle variants are not available')
            return false
          }

          const quantityToAdd = parseInt(
            this.form.querySelector('input[name="quantity"]').value,
          )

          try {
            // Prepare all bundle variants for a single batch request
            const items = this.bundleVariants.map((bundleVariant) => ({
              id: bundleVariant.id,
              quantity: quantityToAdd,
            }))

            // Create config for batch add to cart
            const config = fetchConfig('javascript')
            config.headers['X-Requested-With'] = 'XMLHttpRequest'
            config.body = JSON.stringify({ items })

            const response = await fetch(`${routes.cart_add_url}`, config)
            const responseData = await response.json()

            if (responseData.status) {
              console.error(
                'Error adding bundle variants:',
                responseData.description || responseData.message,
              )
              return false
            }

            return true
          } catch (err) {
            console.error('Error adding bundle variants to cart:', err)
            return false
          }
        }

        async onSubmitHandler(evt) {
          evt.preventDefault()
          evt.stopPropagation()
          evt.stopImmediatePropagation()

          const submitButton = this.querySelector('[type="submit"]')
          const purchaseType = this.getPurchaseType()
          const frequency = this.getFrequency()
          const rechargeVariantId = this.getRechargeVariantId()

          if (submitButton.classList.contains('loading')) {
            return
          }

          // Check if this is a bundle variant FIRST, before any other processing
          if (this.bundleVariants) {
            // Check if all bundle variants are available before proceeding
            if (!this.checkBundleVariantsAvailability()) {
              this.handleErrorMessage(
                'One or more items in this bundle are currently sold out',
              )
              return
            }

            submitButton.setAttribute('aria-disabled', true)
            submitButton.classList.add('loading')
            this.querySelector('.loading-overlay__spinner').classList.remove(
              'hidden',
            )

            try {
              // Always proceed with bundle variant processing
              await this.addBundleVariantsToCart()

              // Calculate total price for conversion tracking
              const quantityToAdd = parseInt(
                this.form.querySelector('input[name="quantity"]').value,
              )
              let totalPrice = 0
              this.bundleVariants.forEach((bundleVariant) => {
                totalPrice += bundleVariant.price * quantityToAdd
              })

              try {
                if (window.rfd) {
                  if (typeof reChargeCartJS !== 'undefined') {
                    window.rfd.renderCart(false, reChargeCartJS)
                  } else {
                    window.rfd.renderCart(false)
                  }
                }
              } catch (e) {
                // Cart render error ignored
              }
            } catch (error) {
              console.error('Bundle variant processing error:', error)
            }

            // Always complete the process for bundle variants
            submitButton.classList.remove('loading')
            submitButton.removeAttribute('aria-disabled')
            this.querySelector('.loading-overlay__spinner').classList.add(
              'hidden',
            )
            return
          }

          this.handleErrorMessage()

          submitButton.setAttribute('aria-disabled', true)
          submitButton.classList.add('loading')
          this.querySelector('.loading-overlay__spinner').classList.remove(
            'hidden',
          )

          // Original logic for single products
          const config = fetchConfig('javascript')
          config.headers['X-Requested-With'] = 'XMLHttpRequest'

          if (purchaseType === 'recurring') {
            const quantityInCart =
              await this.checkVariantQuantity(rechargeVariantId)
            const quantityToAdd = this.form.querySelector(
              'input[name="quantity"]',
            )

            if (quantityInCart >= 5) {
              this.handleErrorMessage('Limit reached')
              submitButton.classList.remove('loading')
              submitButton.removeAttribute('aria-disabled')
              this.querySelector('.loading-overlay__spinner').classList.add(
                'hidden',
              )
              return
            } else if (
              parseInt(quantityToAdd.value) + parseInt(quantityInCart) > 5 ||
              parseInt(quantityToAdd.value) > 5
            ) {
              this.handleErrorMessage('Reduce Quantity')
              submitButton.classList.remove('loading')
              submitButton.removeAttribute('aria-disabled')
              this.querySelector('.loading-overlay__spinner').classList.add(
                'hidden',
              )
              return
            }

            let recurringBody = {
              ...JSON.parse(serializeForm(this.form)),
              // put this stuff back
            }

            recurringBody.id = rechargeVariantId
            recurringBody.properties = {
              shipping_interval_frequency: frequency,
              shipping_interval_unit_type: 'Days',
            }

            config.body = JSON.stringify(recurringBody)
          } else {
            const quantityInCart = await this.checkVariantQuantity(
              this.form.querySelector('[name=id]').value,
            )
            const quantityToAdd = this.form.querySelector(
              'input[name="quantity"]',
            )

            if (quantityInCart >= 5) {
              this.handleErrorMessage('Limit reached')
              submitButton.classList.remove('loading')
              submitButton.removeAttribute('aria-disabled')
              this.querySelector('.loading-overlay__spinner').classList.add(
                'hidden',
              )
              return
            } else if (
              parseInt(quantityToAdd.value) + parseInt(quantityInCart) > 5 ||
              parseInt(quantityToAdd.value) > 5
            ) {
              this.handleErrorMessage('Reduce Quantity')
              submitButton.classList.remove('loading')
              submitButton.removeAttribute('aria-disabled')
              this.querySelector('.loading-overlay__spinner').classList.add(
                'hidden',
              )
              return
            }

            config.body = JSON.stringify({
              ...JSON.parse(serializeForm(this.form)),
              // put this stuff back
            })
          }

          fetch(`${routes.cart_add_url}`, config)
            .then((response) => response.json())
            .then((response) => {
              if (response.status) {
                this.handleErrorMessage(response.description)
                return
              }

              if (window.rfd) {
                if (typeof reChargeCartJS !== 'undefined') {
                  window.rfd.renderCart(false, reChargeCartJS)
                } else {
                  window.rfd.renderCart(false)
                }
              }
            })
            .catch((e) => {
              console.error('Product form submission error:', e)
            })
            .finally(() => {
              submitButton.classList.remove('loading')
              submitButton.removeAttribute('aria-disabled')
              this.querySelector('.loading-overlay__spinner').classList.add(
                'hidden',
              )
            })
        }

        handleErrorMessage(errorMessage = false) {
          this.errorMessageWrapper =
            this.errorMessageWrapper ||
            this.querySelector('.product-form__error-message-wrapper')
          this.errorMessage =
            this.errorMessage ||
            this.errorMessageWrapper.querySelector(
              '.product-form__error-message',
            )

          this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage)

          if (errorMessage) {
            this.errorMessage.textContent = errorMessage
          }
        }
      },
    )
  }
})
